<template>
  <v-row no-gutters>
    <v-col>
      <v-toolbar dense :elevation="0" :class="windowWidth > 870 ? 'toolbar-wrap' : 'rpd-toolbar'">
        <div class="text-primary-700" style="font-weight: 700; display: grid;">
          <span style="font-size: large">Schemes</span>
          <span style="margin-top:-10px">
            <a href="https://rp-database.com/docs/concepts/schemes-properties#scheme-view" target="_blank" rel="noopener noreferrer" class="title-docs" style="font-size: small;">Open Docs</a>
          </span>
        </div>
        <v-btn-toggle class="ml-2"
                      v-model="tableType"
                      group
                      mandatory

        >
        <v-badge class="ml-2" overlap bordered :content="counts.all" :value="counts.all > 0" :style="`margin-right:${badgeMargin(counts.all)}px`">
          <v-btn value="all" :style="counts.all > 9 ? `margin-right:-${badgeMargin(counts.all) - 20}px; padding-right:${badgeMargin(counts.all)}px` : ''">
            All
          </v-btn>
        </v-badge>

        <v-badge class="ml-2" overlap bordered :content="counts.oot" :value="counts.oot > 0" :style="`margin-right:${badgeMargin(counts.oot)}px`">
          <v-btn value="Out of town" :style="counts.oot > 9 ? `margin-right:-${badgeMargin(counts.oot) - 20}px; padding-right:${badgeMargin(counts.oot)}px` : ''">
            Out of town
          </v-btn>
        </v-badge>

        <v-badge class="ml-2" overlap bordered :content="counts.leisure" :value="counts.leisure > 0" :style="`margin-right:${badgeMargin(counts.leisure)}px`">
          <v-btn value="Leisure" :style="counts.leisure > 9 ? `margin-right:-${badgeMargin(counts.leisure) - 20}px; padding-right:${badgeMargin(counts.leisure)}px` : ''">
            Leisure
          </v-btn>
        </v-badge>

        <v-badge class="ml-2" overlap bordered :content="counts.sc" :value="counts.sc > 0" :style="`margin-right:${badgeMargin(counts.sc)}px`">
          <v-btn value="Shopping Centres" :style="counts.sc > 9 ? `margin-right:-${badgeMargin(counts.sc) - 20}px; padding-right:${badgeMargin(counts.sc)}px` : ''">
            Shopping Centres
          </v-btn>
        </v-badge>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <div class="py-2 fit-content ml-4" style="display: flex; float:right; align-items: center">
            <v-switch v-if="isAdmin()" v-model="showUnverified" class="mr-4 align-center" hide-details
                      label="Unverified"></v-switch>
            <v-btn height="40" class="elevation-0 mr-4" color="primary" outlined @click="newScheme">
              <span class="mr-2">New Scheme</span>
              <v-icon size="20">mdi-plus</v-icon>
            </v-btn>
            <v-menu
              v-model="filtersMenu"
              width="500"
              :close-on-content-click="false"
              :nudge-width="300"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-badge class="mr-4" color="red" style="float:right; z-index: 5;" overlap bordered :value="filtersCount > 0">
                <!-- <v-badge class="mr-4 ml-2 mt-1" style="float:right" overlap bordered :content="filtersCount" :value="filtersCount > 0"> -->
                  <v-btn outlined height="40" v-on="on" class="mt-0">
                    <v-icon>mdi-table-search</v-icon> 
                    Filters
                  </v-btn>
                </v-badge>
              </template>

              <v-card width="500">
                <v-card-title>
                  <h4 class="text-primary-700">Filters</h4>
                  <v-spacer></v-spacer>
                  <v-btn class="ml-2" outlined  @click="resetFilters">
                    Reset
                  </v-btn>
                </v-card-title>
                <v-divider class="mx-2"></v-divider>
                <v-card-text class="rpd-filter-card-text pb-8">
                  <h5 class="text-h7 mb-1 pa-0">Landlords</h5>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="landlordFilter"
                        :loading="landlords.loading"
                        :items="landlords.items"
                        :search-input.sync="landlords.search"
                        outlined
                        dense
                        hide-details
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Landlord"
                        @change="getData"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="landlordContactFilter"
                        :loading="landlordContacts.loading"
                        :items="landlordContacts.items"
                        :search-input.sync="landlordContacts.search"
                        outlined
                        hide-details
                        deletable-chips
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Landlord Contacts"
                        @change="() => {getData();}"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="landlordAgentFilter"
                        :loading="landlordAgents.loading"
                        :items="landlordAgents.items"
                        :search-input.sync="landlordAgents.search"
                        outlined
                        deletable-chips
                        hide-details
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Landlord Agents"
                        @change="getData"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="landlordAgentContactFilter"
                        :loading="landlordAgentContacts.loading"
                        :items="landlordAgentContacts.items"
                        :search-input.sync="landlordAgentContacts.search"
                        outlined
                        deletable-chips
                        cache-items
                        hide-details
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Landlord Agent Contacts"
                        @change="() => {getData();}"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-divider class="my-8"></v-divider>
                  
                  <h5 class="text-h7 mb-1 pa-0">Tenants</h5>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="tenantFilter"
                        :loading="tenants.loading"
                        :items="tenants.items"
                        :search-input.sync="tenants.search"
                        outlined
                        dense
                        hide-details
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Tenant"
                        @change="getData"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="legalTenantFilter"
                        :loading="legalTenants.loading"
                        :items="legalTenants.items"
                        :search-input.sync="legalTenants.search"
                        outlined
                        hide-details
                        deletable-chips
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Tenant (Legal)"
                        @change="getData"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="tenantContactFilter"
                        :loading="tenantContacts.loading"
                        :items="tenantContacts.items"
                        :search-input.sync="tenantContacts.search"
                        outlined
                        hide-details
                        deletable-chips
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Tenant Contacts"
                        @change="() => {getData();}"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="tenantAgentFilter"
                        :loading="tenantAgent.loading"
                        :items="tenantAgent.items"
                        :search-input.sync="tenantAgent.search"
                        outlined
                        hide-details
                        deletable-chips
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Tenant Agent"
                        @change="() => {getData();}"
                      ></v-autocomplete> 
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="tenantAgentContactFilter"
                        :loading="tenantAgentContacts.loading"
                        :items="tenantAgentContacts.items"
                        :search-input.sync="tenantAgentContacts.search"
                        outlined
                        hide-details
                        deletable-chips
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Tenant Agent Contacts"
                        @change="() => {getData();}"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-divider class="my-8"></v-divider>

                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                        outlined
                        dense
                        v-model="leaseDataExistsFilter"
                        :items="[{value:1, name:'Yes'}, {value:0, name:'No'}]"
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        item-text="name"
                        item-value="value"
                        label="Lease Data"
                        @change="getData"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>
            </v-menu>
            <v-btn height="40" class="mr-4 elevation-0" @click="exportSchemes" color="primary" :loading="isExporting">
              <span class="mr-2">Export</span>
              <v-icon size="20">mdi-file-excel</v-icon>
            </v-btn>
            <v-row justify="end">
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  v-model="search"
                  append-icon="mdi-table-search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
        </div>
      </v-toolbar>
      <edit-scheme-dialog
        ref="editSchemeDialog"
        @closed="getData"
        @deleted="getData"
      >
      </edit-scheme-dialog>
      <v-card-text class="">
        <v-data-table
          style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;"
          :headers="headers"
          :items="records"
          :options.sync="pagination"
          :loading="loading"
          :server-items-length="totalRecords"
          :items-per-page.sync="itemsPerPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :page.sync="page"
          :multi-sort="false"
          :footer-props="{
                          'items-per-page-options': [50, 100, 500],
                        }"

        >
          <template v-slot:header.properties_with_lease_info_count="{ header }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">Lease data</span>
              </template>
              <p>Displays whether there is any lease data added for this scheme.
                Green means all properties have some data added,
                yellow means some properties have some lease data,
                and red means no properties have lease data.</p>
            </v-tooltip>
          </template>
          <template v-slot:body="{ items }">
            <tbody v-if="initLoader">
              <tr v-for="n in 12" :key="n">
                <td class="px-0 table-loading"  :colspan="headers.length">
                  <v-skeleton-loader
                    type="list-item"
                  ></v-skeleton-loader>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="items.length > 0">
              <tr v-for="item in items" :key="item.id" @click="$refs.editSchemeDialog.showDialog(item.id)" class="row-link">
                <td>{{ item.name }}</td>
                <td>{{ item.address.data.full_address }}</td>
                <td>
                  <a class="mr-1" v-for="(company, index) in item.landlords.data"
                      @click.stop="$refs.companyInfoDialog.showDialog(company.id)">
                    {{ company.name }}<span v-if="index !== (item.landlords.data.length - 1)">,</span>
                  </a>
                  <!--{{ item | landlords}}-->
                </td>
                <td>
                  <a class="mr-1" v-for="(company, index) in item.landlord_agents.data"
                      @click.stop="$refs.companyInfoDialog.showDialog(company.id)">
                    {{ company.name }}<span v-if="index !== (item.landlord_agents.data.length - 1)">,</span>
                  </a>
                  <!--{{ item | landlordAgents}}-->
                </td>
                <td class="text-center">{{ item.is_under_construction ? 'No' : 'Yes' }}</td>
                <td class="text-center">{{ item.properties_count }}</td>
                <td class="text-center">
                  <v-icon v-show="item.properties_with_lease_info_count !== 0 && item.properties_with_lease_info_count === item.properties_count" style="font-size: 10px;" color="green darken-1">mdi-circle</v-icon>
                  <v-icon v-show="item.properties_with_lease_info_count > 0 && item.properties_with_lease_info_count < item.properties_count" style="font-size: 10px;" color="yellow darken-1">mdi-circle</v-icon>
                  <v-icon v-show="item.properties_with_lease_info_count === 0" style="font-size: 10px;" color="red darken-1">mdi-circle</v-icon>
                </td>
                <!--                            <td>-->
                <!--                                <v-chip small label @click="showDocuments(item)">-->
                <!--                                    {{ item.documents_count }}-->
                <!--                                </v-chip>-->
                <!--                            </td>-->
                <td class="text-center px-2">
                  <v-menu v-if="item.unverified_history_count > 0"
                          max-width="200px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        class="mx-1 table-icon-btn"
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-help
                      </v-icon>
                    </template>

                    <v-card>
                      <v-card-text>
                           <span>There are some changes to this entity that have not been verified by admin.
                               Please <a @click.stop="routeToEdit(item.id, 'entityHistoryBlock')">view the history of the entity</a> to see more information.</span>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                  <v-icon class="mx-1 table-icon-btn" v-if="item.properties_count <= 1" @click.stop="convertToProperty(item.id, item.name)"
                          small title="Convert to Standalone property">
                    mdi-home
                  </v-icon>
                  <v-icon @click.stop="routeToEdit(item.id)"
                          small
                          class="mx-1 table-icon-btn"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon v-if="isAdmin()" @click.stop="deleteScheme(item.id, item.name)"
                          small
                          class="mx-1 table-icon-btn"
                  >
                    mdi-delete
                  </v-icon>
                  <v-icon @click.stop="routeToMap(item)" small class="mx-1 table-icon-btn" title="View on map">
                    mdi-google-maps
                  </v-icon>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td class="text-center" :colspan="headers.length">
                        No records found
                    </td>
                </tr>
              </tbody>
          </template>
        </v-data-table>
      </v-card-text>
      <company-info-dialog ref="companyInfoDialog"></company-info-dialog>
      <files-dialog ref="schemeListFilesDialog"></files-dialog>
      <add-scheme-dialog ref="addSchemeDialog" @added="getData"></add-scheme-dialog>
      <!-- <v-btn
        fab
        dark
        bottom
        right
        fixed
        color="primary"
        :to="'/schemes/create'"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn> -->
    </v-col>
  </v-row>

</template>

<script>
import EditSchemeDialog from '@/components/schemes/editSchemeDialog'
import CompanyInfoDialog from '@/components/info/companyInfoDialog'
import FilesDialog from '@/components/common/filesDialog'
import AddSchemeDialog from '@/components/schemes/addSchemeDialog'

export default {
  components: {
    EditSchemeDialog,
    CompanyInfoDialog,
    FilesDialog,
    AddSchemeDialog
  },
  data() {
    return {
      // landlordFilter: null,
      // landlordAgentFilter: null,
      // tenantFilter: null,
      // leaseDataExistsFilter: null,
      filtersMenu: false,

      isExporting: false,
      showUnverified: false,
      // search: '',
      pagination: {},
      totalRecords: 0,
      loading: false,
      initLoader: true,
      sortBy: ['id'],
      sortDesc: [true],
      itemsPerPage: 50,
      page: 1,
      tableType: 'all',

      counts: {
        all: 0,
        oot: 0,
        leisure: 0,
        sc: 0,
      },

      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Address', value: 'address', sortable: false},
        {text: 'Landlords', value: 'landlords', sortable: false},
        {text: 'Landlords Agents', value: 'landlord_agents', sortable: false},
        {text: 'Opened', value: 'is_under_construction', class:'data-table__cell'},
        {text: 'No. of properties', value: 'properties_count', class:'data-table__cell'},
        {text: 'Lease data', value: 'properties_with_lease_info_count', class:'data-table__cell'},
        // {text: 'No. of files', value: 'documents_count'},
        {text: 'Actions', sortable: false, align: 'center'}
      ],
      records: [],
      landlords: {
        loading: false,
        items: [],
        search: null,
      },
      landlordAgents: {
        loading: false,
        items: [],
        search: null,
      },
      tenants: {
        loading: false,
        items: [],
        search: null,
      },
      tenantContacts: {
        loading: false,
        items: [],
        search: null,
      },
      landlordContacts: {
        loading: false,
        items: [],
        search: null,
      },
      landlordAgentContacts: {
        loading: false,
        items: [],
        search: null,
      },
      tenantAgent: {
        loading: false,
        items: [],
        search: null,
      },
      tenantAgentContacts: {
        loading: false,
        items: [],
        search: null,
      },
      legalTenants: {
        loading: false,
        items: [],
        search: null,
      },
      _timerId: null,
    }
  },
  mounted() {
    this.handleRouteQuery();
    this.getCounts();
    // this.getData()
  },
  filters: {
    landlords(item) {
      return item.landlords.data.map(elem => {
        return elem.name;
      }).join(', ');
    },
    landlordAgents(item) {
      return item.landlord_agents.data.map(elem => {
        return elem.name;
      }).join(', ');
    }
  },
  watch: {
    async filtersMenu(val) {
      if (val) {
        if (this.tenantFilter) {
          const promises = this.tenantFilter.map(id => this.getCompanyById(id));
          this.tenants.items = await Promise.all(promises);
        }
        if (this.landlordFilter) {
          const promises = this.landlordFilter.map(id => this.getCompanyById(id));
          this.landlords.items = await Promise.all(promises);
        }
        if (this.landlordAgentFilter) {
          const promises = this.landlordAgentFilter.map(id => this.getCompanyById(id));
          this.landlordAgents.items = await Promise.all(promises);
        }
        if (this.tenantContactFilter) {
          const promises = this.tenantContactFilter.map(id => this.getContactById(id));
          this.tenantContacts.items = await Promise.all(promises);
        }
        if (this.landlordContactFilter) {
          const promises = this.landlordContactFilter.map(id => this.getContactById(id));
          this.landlordContacts.items = await Promise.all(promises);
        }
        if (this.landlordAgentContactFilter) {
          const promises = this.landlordAgentContactFilter.map(id => this.getContactById(id));
          this.landlordAgentContacts.items = await Promise.all(promises);
        }
        if (this.legalTenantFilter) {
          const promises = this.legalTenantFilter.map(id => this.getCompanyById(id));
          this.legalTenants.items = await Promise.all(promises);
        }
        if (this.tenantAgentFilter) {
          const promises = this.tenantAgentFilter.map(id => this.getCompanyById(id));
          this.tenantAgent.items = await Promise.all(promises);
        }
        if (this.tenantAgentContactFilter) {
          const promises = this.tenantAgentContactFilter.map(id => this.getContactById(id));
          this.tenantAgentContacts.items = await Promise.all(promises);
        }

      }
    },
    pagination: {
      handler() {
        this.getData()
      },
      deep: true
    },
    search() {
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        this.page = 1
        this.getData()
      }, 500)
    },
    page() {
      this.$vuetify.goTo(1)
    },
    tableType(type) {
      this.getData()
    },
    showUnverified() {
      this.getData()
    },
    'landlords.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlords()
      }, 375);
    },
    'landlordAgents.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordAgents()
      }, 375);
    },
    'tenants.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenants()
      }, 375);
    },
    'tenantContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenantContacts()
      }, 375);
    },
    'landlordContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordContacts()
      }, 375);
    },
    'landlordAgentContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordAgentContacts()
      }, 375);
    },
    'tenantAgent.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenantAgents(search);
      }, 375);
    },
    'tenantAgentContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenantAgentContacts(search);
      }, 375);
    },
    'legalTenants.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLegalTenants(search);
      }, 375);
    },
  },
  computed: {
    windowWidth() {
      return this.$vuetify.breakpoint.width;
    },
    isFiltersActive() {
      return this.landlordFilter
        || this.landlordAgentFilter
        || this.tenantFilter
        || this.tenantContactFilter
        || this.landlordContactFilter
        || this.landlordAgentContactFilter
        || this.leaseDataExistsFilter != null
        || this.tenantAgentFilter
        || this.tenantAgentContactFilter
        || this.legalTenantFilter
    },
    filtersCount(){
      let count = 0;
      if (this.landlordFilter && this.landlordFilter.length > 0) count++;
      if (this.landlordAgentFilter && this.landlordAgentFilter.length > 0) count++;
      if (this.tenantFilter && this.tenantFilter.length > 0) count++;
      if (this.tenantContactFilter && this.tenantContactFilter.length > 0) count++;
      if (this.landlordContactFilter && this.landlordContactFilter.length > 0) count++;
      if (this.landlordAgentContactFilter && this.landlordAgentContactFilter.length > 0) count++;
      if (this.leaseDataExistsFilter != null) count++;
      return count;
    },
    // tableType: {
    //   get() {
    //     return this.$store.state.schemes.filters.tableType
    //   },
    //   set(value) {
    //     this.$store.commit('updateSchemesFilters', {key: 'tableType', value: value})
    //   }
    // },
    search: {
      get () {
        return this.$store.state.schemes.filters.search
      },
      set (value) {
        this.$store.commit('updateSchemesFilters', {key: 'search', value: value})
      }
    },

    landlordFilter: {
      get() {
        return this.$store.state.schemes.filters.landlordFilter
      },
      set(value) {
        this.$store.commit('updateSchemesFilters', {key: 'landlordFilter', value: value})
      }
    },
    landlordAgentFilter: {
      get() {
        return this.$store.state.schemes.filters.landlordAgentFilter
      },
      set(value) {
        this.$store.commit('updateSchemesFilters', {key: 'landlordAgentFilter', value: value})
      }
    },
    tenantFilter: {
      get() {
        return this.$store.state.schemes.filters.tenantFilter;
      },
      set(value) {
        this.$store.commit('updateSchemesFilters', {key: 'tenantFilter', value: value})
      }
    },
    legalTenantFilter: {
      get() {
        return this.$store.state.schemes.filters.legalTenantFilter;
      },
      set(value) {
        this.$store.commit('updateSchemesFilters', {key: 'legalTenantFilter', value: value})
      }
    },
    tenantContactFilter: {
      get() {
        return this.$store.state.schemes.filters.tenantContactFilter;
      },
      set(value) {
        this.$store.commit('updateSchemesFilters', {key: 'tenantContactFilter', value: value})
      }
    },
    landlordContactFilter: {
      get() {
        return this.$store.state.schemes.filters.landlordContactFilter;
      },
      set(value) {
        this.$store.commit('updateSchemesFilters', {key: 'landlordContactFilter', value: value})
      }
    },
    landlordAgentContactFilter: {
      get() {
        return this.$store.state.schemes.filters.landlordAgentContactFilter;
      },
      set(value) {
        this.$store.commit('updateSchemesFilters', {key: 'landlordAgentContactFilter', value: value})
      }
    },
    tenantAgentFilter: {
      get() {
        return this.$store.state.schemes.filters.tenantAgentFilter;
      },
      set(value) {
        this.$store.commit('updateSchemesFilters', {key: 'tenantAgentFilter', value: value})
      }
    },
    tenantAgentContactFilter: {
      get() {
        return this.$store.state.schemes.filters.tenantAgentContacts;
      },
      set(value) {
        this.$store.commit('updateSchemesFilters', {key: 'tenantAgentContacts', value: value})
      }
    },
    leaseDataExistsFilter: {
      get() {
        return this.$store.state.schemes.filters.leaseDataExistsFilter;
      },
      set(value) {
        this.$store.commit('updateSchemesFilters', {key: 'leaseDataExistsFilter', value: value})
      }
    },

  },
  methods: {
    badgeMargin(count) {
      // return an increase in the margin for the badge based on the digit, the breakpoints increasing at 10, 100, 1000, 10000, 100000 etc
      if (count < 10) return 5;
      if (count < 100) return 20;
      if (count < 1000) return 25;
      if (count < 10000) return 30;
      if (count < 100000) return 35;

    },
    getCounts(){
      this.$http.get('/schemes/counts').then(({data}) => {
        this.counts.all = data.all;
        this.counts.oot = data['Out of town'];
        this.counts.leisure = data.Leisure;
        this.counts.sc = data['Shopping Centres'];
      })
    },
    resetFilters() {
      this.$store.commit('resetSchemesFilters');
      this.getData()
    },
    async getCompanyById(id) {
      const response = await this.$http.get(`/companies/${id}`);
      return response.data;
    },
    async getContactById(id) {
      const response = await this.$http.get(`/users/${id}`);
      return response.data;
    },
    routeToEdit(id, scroll) {
      this.$refs.editSchemeDialog.showDialog(id, scroll);
      // this.$router.push({name: 'companies.edit', params: {id: id}})
    },

    newScheme() {
      this.$refs.addSchemeDialog.openDialog();
    },

    routeToMap(item) {
      this.$router.push({name: 'map', params: {scheme: item}})
    },
    async deleteScheme(id, name) {
      // this.$notify.question(`Do you want to remove ${name}?`, () => {
      //   this.$http.delete(`/schemes/${id}`).then(() => {
      //     this.getData()
      //   })
      // })

      const {data} = await this.$http.get(`/schemes/${id}/check-destroy`);
      let filesWarning = ''
      let commentsWarning = ''
      if (data.comments) {
        commentsWarning = `</br><b>${data.comments} comments!</b>`
      }
      if (data.files) {
        filesWarning = `</br><b>${data.files} files!</b>`
      }
      this.$notify.question(`Do you want to remove ${name}?</br> Scheme cannot be recovered and is not saved in history!</br>${filesWarning}${commentsWarning}`, () => {
        this.$http.delete(`/scheme/${id}`).then(() => {
          this.getData()
        })
      })
    },
    async convertToProperty(id, name) {
      this.$notify.question(`Do you want to convert ${name} to standalone property?`, () => {
        this.$http.post(`/schemes/${id}/convert`).then(() => {
          this.getData()
        })
      })
    },
    getData() {
      this.loading = true
      this.$http.get('/schemes', {
        params: {
          q: this.search,
          page: this.pagination.page,
          sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
          desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
          per_page: this.pagination.itemsPerPage,
          include: 'address,landlords,landlord_agents',
          type: this.tableType,
          show_unverified: this.showUnverified ? 1 : 0,
          landlord_id: this.landlordFilter,
          landlord_agent_id: this.landlordAgentFilter,
          tenant_id: this.tenantFilter,
          tenant_contact_id: this.tenantContactFilter,
          landlord_contact_id: this.landlordContactFilter,
          landlord_agent_contact_id: this.landlordAgentContactFilter,
          lease_data_exists: this.leaseDataExistsFilter,
          tenant_agent_id: this.tenantAgentFilter,
          tenant_agent_contact_id: this.tenantAgentContactFilter,
          legal_tenant_id: this.legalTenantFilter,
        }
      }).then(response => {
        const pagination = response.data.meta.pagination
        this.totalRecords = pagination.total
        this.records = response.data.data
        this.loading = false
        this.initLoader = false
      }).catch(() => {
        this.loading = false
        this.initLoader = false
      })
    },
    exportSchemes() {
      this.isExporting = true;
      this.$http.get('/schemes/export', {
        responseType: 'blob',
        params: {
          q: this.search,
          sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
          desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
          type: this.tableType,
          landlord_id: this.landlordFilter,
          landlord_agent_id: this.landlordAgentFilter,
          tenant_id: this.tenantFilter,
          tenant_contact_id: this.tenantContactFilter,
          landlord_contact_id: this.landlordContactFilter,
          landlord_agent_contact_id: this.landlordAgentContactFilter,
          lease_data_exists: this.leaseDataExistsFilter,
        },
      }).then((response) => {
        this.isExporting = false;
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'schemes.xlsx');
        document.body.appendChild(fileLink);
        fileLink.click();
      }).catch((e) => {
        this.isExporting = false;
      });
    },
    showDocuments(item) {
      this.$refs.schemeListFilesDialog.showDialog(item.id, 'scheme', 'tab-files');
    },
    async getLandlords() {
      const response = await this.$http.get('/companies/', {
        params: {
          q: this.landlords.search,
          per_page: 100,
        }
      });
      this.landlords.items = response.data.data;
    },
    async getLandlordAgents() {
      const response = await this.$http.get('/companies/', {
        params: {
          q: this.landlordAgents.search,
          per_page: 100,
        }
      });
      this.landlordAgents.items = response.data.data;
    },
    async getTenants() {
      const response = await this.$http.get('/companies/', {
        params: {
          q: this.tenants.search,
          per_page: 100,
        }
      });
      this.tenants.items = response.data.data;
    },
    async getTenantContacts() {
      const response = await this.$http.get('/users/', {
        params: {
          q: this.tenantContacts.search,
          per_page: 100,
        }
      });
      this.tenantContacts.items = response.data.data;
    },
    async getLandlordContacts() {
      const response = await this.$http.get('/users/', {
        params: {
          q: this.landlordContacts.search,
          per_page: 100,
        }
      });
      this.landlordContacts.items = response.data.data;
    },
    async getLandlordAgentContacts() {
      const response = await this.$http.get('/users/', {
        params: {
          q: this.landlordAgentContacts.search,
          per_page: 100,
        }
      });
      this.landlordAgentContacts.items = response.data.data;
    },
    async getLegalTenants(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.legalTenants.items = response.data.data;
    },
    async getTenantAgents(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenantAgent.items = response.data.data;
    },
    async getTenantAgentContacts(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
          include: 'company',
        }
      });
      this.tenantAgentContacts.items = response.data.data;
    },
    async getTenantContacts(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenantContacts.items = response.data.data;
    },

    // handle route query params
    async handleRouteQuery(){
      const query = this.$route.query;
      if (query.id) {
        this.$refs.editSchemeDialog.showDialog(query.id);
      }
    },

    debounce(fn, delay) {
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        fn();
      }, delay);
    }
  }
}
</script>

<style scoped>
.table-link {
  text-decoration: none;
}
</style>
